import React from 'react';
import { Instagram, Phone, MapPin, Clock } from 'lucide-react';
import { BRAND } from '../mock';

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.45a8.16 8.16 0 0 0 4.77 1.52V6.55a4.85 4.85 0 0 1-1.84-.16z"/>
  </svg>
);

const FacebookIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06C2 17.08 5.66 21.25 10.44 22v-7.03H7.9v-2.91h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.24.19 2.24.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.77l-.44 2.91h-2.33V22C18.34 21.25 22 17.08 22 12.06z"/>
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-[color:var(--ink)] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt="Trust Me" className="h-12 w-12 rounded-full object-cover ring-2 ring-[color:var(--brand)]/40" />
            <div>
              <div className="font-display font-extrabold tracking-tight">TRUST ME</div>
              <div className="text-[11px] tracking-[0.25em] text-[color:var(--brand)] font-semibold">LAUNDRY</div>
            </div>
          </div>
          <p className="text-sm text-white/70 mt-5 leading-relaxed">
            <b>Trust Me Laundry Express</b> adalah layanan laundry kiloan dan satuan. Tim profesional yang mengutamakan kualitas cucian & pelayanan: bersih, rapi, wangi, higienis & tepat waktu.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href={BRAND.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="h-9 w-9 rounded-full bg-white/10 hover:bg-[color:var(--brand)] flex items-center justify-center transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={BRAND.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok" className="h-9 w-9 rounded-full bg-white/10 hover:bg-[color:var(--brand)] flex items-center justify-center transition-colors">
              <TikTokIcon className="w-4 h-4" />
            </a>
            <a href={BRAND.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="h-9 w-9 rounded-full bg-white/10 hover:bg-[color:var(--brand)] flex items-center justify-center transition-colors">
              <FacebookIcon className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-semibold mb-5 uppercase tracking-wider text-sm">Menu</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><a href="#home" className="hover:text-[color:var(--brand)]">Beranda</a></li>
            <li><a href="#services" className="hover:text-[color:var(--brand)]">Layanan</a></li>
            <li><a href="#about" className="hover:text-[color:var(--brand)]">Tentang</a></li>
            <li><a href="#outlets" className="hover:text-[color:var(--brand)]">Outlet</a></li>
            <li><a href="#testimonials" className="hover:text-[color:var(--brand)]">Testimoni</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-5 uppercase tracking-wider text-sm">Kontak</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[color:var(--brand)] flex-shrink-0" /> <a href={`tel:${BRAND.phoneLink}`} className="hover:text-white">{BRAND.phone}</a></li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-[color:var(--brand)] mt-0.5 flex-shrink-0" /> <span>Apartemen Kebagusan City,<br />Kebagusan, Ps. Minggu,<br />Jakarta Selatan 12520</span></li>
            <li className="flex items-center gap-2"><Clock className="w-4 h-4 text-[color:var(--brand)] flex-shrink-0" /> <span>Setiap hari • 08:00 – 20:00</span></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-5 uppercase tracking-wider text-sm">Newsletter</h4>
          <p className="text-sm text-white/70 mb-3">Dapatkan promo & tips merawat pakaian.</p>
          <form onSubmit={(e) => e.preventDefault()} className="flex">
            <input type="email" placeholder="Email Anda" className="flex-1 px-4 h-11 rounded-l-lg bg-white/10 border border-white/10 text-sm placeholder:text-white/40 focus:outline-none focus:border-[color:var(--brand)]" />
            <button className="px-4 h-11 bg-[color:var(--brand)] hover:bg-[color:var(--brand-600)] rounded-r-lg text-sm font-semibold transition-colors">Daftar</button>
          </form>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs text-white/50 text-center md:text-left">Copyright © Trust Me Laundry {new Date().getFullYear()}. All rights reserved.</p>
        <p className="text-xs text-white/50">Bersih • Wangi • Higienis • Tepat Waktu</p>
      </div>
    </footer>
  );
};

export default Footer;
